import { BRIDGE_VERSION, SCHEMA } from './bridge-const';

export default (name, curVer, env) => {
    const verConf = BRIDGE_VERSION[name];
    if (!verConf || !verConf[env]) {
        return true;
    }
    if (verConf[env] === 'unknown') return false;
    return checkAppVersion(curVer, verConf[env]) > -1;
};

export const checkSchemaVersion = (name, curVer, env) => {
    const verConf = SCHEMA[name];
    if (!verConf || !verConf['version'] || !verConf['version'][env]) {
        return true;
    }
    if (verConf['version'][env] === 'unknown') return false;
    return checkAppVersion(curVer, verConf['version'][env]) > -1;
};

// 按位比较版本号 -1 小于， 0 等于， 1 大于
export const checkAppVersion = (ver1 = '', ver2 = '') => {
    let result = 0;
    if (`${ver1}` === `${ver2}`) {
        return result;
    } else if (`${ver1}` !== '') {
        const v1 = `${ver1}`.split('.'),
            v2 = `${ver2}`.split('.');
        v1.every((i, index) => {
            if (typeof v2[index] === 'undefined' || i * 1 > v2[index] * 1) {
                result = 1;
                return false;
            } else if (i * 1 < v2[index] * 1) {
                result = -1;
                return false;
            }
            return true;
        });
        return result;
    }
    return -1;
};



// WEBPACK FOOTER //
// ./src/util/jsbridge/check-version.js